// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rd-2";
export var chatLink = "_rd-0";
export var chatText = "_rd-1";